import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../authentication/session.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: [
    '../organic/signup/signup.component.css',
    '../login/login.component.css',
    '../organic/login/login.component.css',
  ],
})
export class ResetpasswordComponent implements OnInit {
  // password: string = '';
  // confirmPassword: string = '';
  token: string;
  userID: string;

  public resetInformation: string =
    'Choose a strong password that you can easily remember, and make sure it helps keep your account secure';
  public resetInformationError: string;
  public warningMatch: string = 'Your password does not match!';
  public resetStatus: string = 'SUBMIT';
  public resetLoading: boolean = false;
  public finishedSend: boolean = false;
  public passwordValidation: boolean = false;
  public passwordValidationWarning: number;

  constructor(
    private authService: SessionService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private titleService: Title,
    private localStorageService: LocalStorageService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.token = params['token'];
      this.userID = params['userId'];
    });
  }

  form = this.fb.group({
    password: ['', Validators.required],
    confirmPassword: ['', Validators.required],
  });

  isWhiteLabel: boolean = false;

  ngOnInit() {
    this.isWhiteLabel = this.localStorageService.get('isWhiteLabel') || false;
    if (this.isWhiteLabel) {
      this.titleService.setTitle('Reset Password - Paid');
    } else {
      this.titleService.setTitle('Reset Password - Behamics');
    }
  }

  resetPassword() {
    if (this.form.invalid) return;

    let password = this.form.value.password || '';
    let confirmPassword = this.form.value.confirmPassword || '';

    if (password == confirmPassword) {
      this.resetStatus = 'REQUESTING...';
      this.resetLoading = true;
      // this.resetInformation = '';
      this.resetInformationError = '';
      this.authService
        .resetPassword(password, this.token, this.userID)
        .subscribe({
          next: (data: any) => {
            if (data['status'] == 3) {
              this.resetStatus = 'LOGGING IN...';

              // Login user if password reset is successful
              this.authService.login(data);
              this.authService.navigate(data);
            } else {
              this.resetStatus = 'SENT';
              this.resetLoading = false;
              this.finishedSend = true;
            }
          },
          error: (error: any) => {
            this.passwordValidationWarning = 2;
            this.resetInformationError = error.error.message;
            this.resetStatus = 'SUBMIT';
            this.resetLoading = false;
            console.log(error);
          },
        });
    } else {
      this.passwordValidationWarning = 1;
      this.warningMatch = 'Your password does not match!';
      this.passwordValidation = false;
    }
  }

  showPassword: boolean = false;
  toogleShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
